import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

// Нажатие не уводит фокус из поля ввода: клавиатура остаётся открытой.
export function keepInputFocus(event: { preventDefault: () => void }) {
	event.preventDefault()
}
